import { defineMessages } from 'react-intl';

export default defineMessages({
	heading: {
		id: 'familyPlanLanding.faq.heading',
		defaultMessage: 'Frequently asked questions',
		description: 'Heading for faq section',
	},
	question1: {
		id: 'familyPlanLanding.faq.question1',
		defaultMessage:
			'I already have a subscription to Calm Premium. How do I switch to a Calm Premium Family plan?',
		description: 'Question in FAQ',
	},
	answer1: {
		id: 'familyPlanLanding.faq.answer1',
		defaultMessage:
			'Current Calm users can switch to Calm Premium Family from their current subscription at any time, as the plan admin or a plan member, without losing your saved favorites, downloads, or session history.{break}The cost of a previously purchased subscription cannot be applied towards the cost of a Family plan.{break}We encourage all yearly subscribers to <externallink>cancel the auto-renew</externallink> of their yearly subscription if they’d like to purchase Calm Premium Family.',
		description: 'Answer in FAQ',
	},
	question2: {
		id: 'familyPlanLanding.faq.question2',
		defaultMessage: 'How does billing work? Can we split the cost of the membership between each individual?',
		description: 'Question in FAQ',
	},
	answer2: {
		id: 'familyPlanLanding.faq.answer2',
		defaultMessage:
			'Calm Premium Family is billed for a full year to the payment method provided at check-out and is set to renew annually. Until the Family plan has been canceled, it will be billed automatically each year to the person who originally purchased the Calm Premium Family plan.',
		description: 'Answer in FAQ',
	},
	question3: {
		id: 'familyPlanLanding.faq.question3',
		defaultMessage: 'Who can join my Family plan?',
		description: 'Question in FAQ',
	},
	answer3: {
		id: 'familyPlanLanding.faq.answer3',
		defaultMessage:
			'Calm Premium Family allows up to 6 friends and family members (who may or may not live with you!) to receive access to Calm Premium for one yearly payment. Calm Premium Family Member must be 18 years of age or older.',
		description: 'Answer in FAQ',
	},
	question4: {
		id: 'familyPlanLanding.faq.question4',
		defaultMessage:
			'Do my family plan members all share a single Calm account or do we each get our own account?',
		description: 'Question in FAQ',
	},
	answer4: {
		id: 'familyPlanLanding.faq.answer4',
		defaultMessage:
			'Each Calm Premium Family Member has their own Calm account and logs in to their account using a unique email address and password. Session history, stats, check ins, and other personal information tied to a Calm account are not shared between Calm Premium Family Members.',
		description: 'Answer in FAQ',
	},
	cta: {
		id: 'familyPlanLanding.faq.cta',
		defaultMessage: 'Get Premium Family',
		description: 'Cta for faq section',
	},
});
